import React, { useEffect, useState, useContext } from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import { MainColors } from '../../constants/Colors';
import LoadingIndicator from '../../components/ActivityIndicator';
import FontSizes from '../../constants/FontSizes';
import MainButton from '../../components/Buttons/MainButton';
import { AuthContext } from '../../context/AuthProvider'
import TwoLineMessage from '../../components/TwoLineMessage';
import useFetch from '../../utils/useFetch';
import InfoMessageBox from '../../components/InfoMessageBox';
import VotedOnMessageBox from './VotedOnMessageBox';

const BallotDetailsScreen = ({ route, navigation }) => {
    const isFocused = useIsFocused();
    const { ballotId } = route.params;
    const [ballot, setBallot] = useState();
    const { isVoterInOrganization } = useContext(AuthContext);
    const { get, isLoading } = useFetch();

    useEffect(() => {
        async function getBallotsDetails() {
            const response = await get(`/api/ballots/${ballotId}`);
            setBallot(response);
        }
        getBallotsDetails();
    }, [isFocused]);

    return (
        <View style={styles.screen}>
            <LoadingIndicator isLoading={isLoading}>
                {ballot ? (
                    <>
                        <View style={styles.ballotTitleContainer}>
                            <Text style={styles.title}>{ballot.title}</Text>
                        </View>
                        <ScrollView style={styles.container}>
                            {ballot.description ?
                                <Text style={styles.description}>{ballot.description}</Text>
                                :
                                null
                            }

                            {ballot.canBallotBeVotedUpon ? (
                                ballot.hasBallotBeenVotedOnByCurrentUser ?
                                    (
                                        <VotedOnMessageBox style={{ marginTop: 30 }}
                                            messageTitle="Your vote on this ballot has been submitted." messageText="Thank you for your participation!  😎" />
                                    )
                                    : (
                                        <View style={styles.mainButtonContainer}>
                                            {isVoterInOrganization ? (
                                                <MainButton
                                                    onPress={() => navigation.navigate('Vote', {
                                                        ballotId,
                                                        ballotItemIndex: undefined
                                                    })}
                                                    text={'Participate'}
                                                    accessibilityLabel="Participate"
                                                    accessibilityHint="Press this button to participate on voting for this ballot"
                                                />
                                            ) : (
                                                    <View style={styles.warningMessageContainer}>
                                                        <Text style={styles.warningMessageText}>You do not have voting priviledges for this ballot.</Text>
                                                    </View>
                                                )}
                                        </View>
                                    )
                            ) : (
                                    <InfoMessageBox style={{ marginTop: 30 }}
                                        messageText={`This ballot is ${ballot.status.toLowerCase()} and cannot be voted on.`}
                                    />
                                )
                            }
                        </ScrollView>
                    </>
                ) : (null)}

            </LoadingIndicator>
        </View>
    );
}

export const screenOptions = () => {
    return {
        headerTitle: 'Ballot Details'
    }
}

const styles = StyleSheet.create({
    screen: {
        flex: 1
    },
    container: {
        paddingHorizontal: 20
    },
    ballotTitleContainer: {
        padding: 20,
        borderBottomColor: MainColors.faintGray,
        borderBottomWidth: 1
    },
    title: {
        textAlign: 'center',
        fontSize: FontSizes.large,
        fontWeight: '600',
        letterSpacing: 0.5,
        lineHeight: 24,
        color: MainColors.darkGray,
        letterSpacing: 0.5,
    },
    dateRange: {
        alignSelf: 'center',
        fontSize: FontSizes.small,
        color: MainColors.mediumGray,
        marginBottom: 20,
        fontWeight: '500'
    },
    progressBar: {
        height: 14,
        borderRadius: 10,
        backgroundColor: MainColors.faintGray
    },
    percentVotedLabel: {
        textAlign: 'right',
        color: MainColors.mediumGray,
        fontSize: FontSizes.extraSmall
    },
    description: {
        paddingTop: 20,
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        alignSelf: 'center',
        lineHeight: 28
    },
    mainButtonContainer: {
        marginVertical: 30
    },
    warningMessageContainer: {
        backgroundColor: '#FFFBE7',
        borderRadius: 8,
        padding: 10,
        alignItems: 'center',
        marginBottom: 30,
        borderWidth: 2,
        borderColor: '#B89900'
    },
    warningMessageText: {
        textAlign: 'center',
        color: '#B89900',
        fontSize: FontSizes.medium,
        fontWeight: '600',
        letterSpacing: 0.5,
        lineHeight: 24
    }
});

export default BallotDetailsScreen;